import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ServiceSwitcher.css';

export interface ServiceSwitcherOption {
  id: string;
  label: string;
  logo: string;
  active: boolean;
  onSelect: () => void;
}

interface ServiceSwitcherProps {
  visible: boolean;
  currentLabel: string;
  currentLogo: string;
  options: ServiceSwitcherOption[];
}

export const ServiceSwitcher: React.FC<ServiceSwitcherProps> = ({
  visible,
  currentLabel,
  currentLogo,
  options,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (!visible) {
    return <img src={currentLogo} alt={currentLabel} className="service-switcher-logo" />;
  }

  return (
    <div className="service-switcher">
      <button
        className="service-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={currentLabel}
      >
        <span className="material-icons service-switcher-icon">grid_view</span>
        <img src={currentLogo} alt={currentLabel} className="service-switcher-logo" />
        <span className="material-icons service-switcher-chevron">expand_more</span>
      </button>

      {open && (
        <>
          <div className="service-switcher-backdrop" onClick={() => setOpen(false)} />
          <div className="service-switcher-dropdown" role="listbox">
            <div className="service-switcher-heading">{t('serviceSwitcher.suiteTitle')}</div>
            {options.map((option) => (
              <button
                key={option.id}
                role="option"
                aria-selected={option.active}
                className={`service-switcher-option${option.active ? ' active' : ''}`}
                onClick={() => {
                  setOpen(false);
                  option.onSelect();
                }}
              >
                {option.active ? (
                  <span className="material-icons service-switcher-check">check</span>
                ) : (
                  <span className="service-switcher-check-placeholder" />
                )}
                <img src={option.logo} alt={option.label} className="service-switcher-option-logo" />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ServiceSwitcher;
